import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import injectSheet from 'react-jss';

import DropdownMenu from '../DropdownMenu';
import UserImage from './UserImage';
import UserInfo from './UserInfo';
import Paper from '@material-ui/core/Paper';

class User extends React.PureComponent {
    onSelect = e => {
        const { onSelect, user, actions } = this.props;
        if (!actions.length) {
            return;
        }
        onSelect(user, e.shiftKey);
    };

    onAction = action => {
        const { onAction, user } = this.props;
        onAction([user.id], action);
    };

    render() {
        const { user, isSelected, actions, showActions, classes } = this.props;
        const userClasses = classNames(classes.wrapper, {
            [classes.selected]: isSelected,
            [classes.selectDisabled]: actions.length === 0,
        });

        let actionsMenu;
        if (showActions && actions.length) {
            actionsMenu = (
                <DropdownMenu actions={actions} onClick={this.onAction} />
            );
        }

        return (
            <Paper square elevation={1} className={userClasses}>
                <div className={classes.select} onClick={this.onSelect}>
                    <UserImage
                        isSelected={isSelected}
                        picture={user.pictureSmallURL}
                    />
                    <UserInfo user={user} />
                </div>
                <div className={classes.actionWrapper}>
                    {user.isAdmin && (
                        <span className={classes.role}>Admin</span>
                    )}
                    <div className={classes.actionMenu}>{actionsMenu}</div>
                </div>
            </Paper>
        );
    }
}

User.propTypes = {
    user: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired,
    actions: PropTypes.array,
    onAction: PropTypes.func,
    showActions: PropTypes.bool,
};

User.defaultProps = {
    actions: [],
    onAction: undefined,
    showActions: true,
};

const style = ({ palette, spacing, overrides }) => ({
    wrapper: {
        display: 'flex',
        alignItems: 'strech',
        flexGrow: 1,
        '&:hover': {
            backgroundColor: palette.background.gray1Color,
        },
    },
    actionWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    selected: {
        background: palette.background.gray1Color,
    },
    select: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        cursor: 'pointer',
        padding: [spacing.unit * 2, 0, spacing.unit * 2, spacing.unit * 3],
    },
    selectDisabled: {
        '& $select': {
            cursor: 'auto',
        },
    },
    role: {
        marginRight: spacing.unit * 4,
        color: palette.text.secondary,
    },
    actionMenu: {
        minWidth: overrides.MuiIconButton.root.width,
        marginRight: spacing.unit * 2,
    },
});

export default injectSheet(style)(User);



// WEBPACK FOOTER //
// ./src/components/users/User.js